import { MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH, PC_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: black;
`;
export const FooterLine = styled.div`
  border-top: 1px solid #222222;
`;
export const Container = styled.div`
  width: 120rem;
  margin: auto;
  margin-top: 6rem;
  display: flex;

  @media screen and (max-width: ${PC_LAYOUT_LENGTH}) {
    width: 100%;
    padding: 0 20px;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column;
  }
`;

export const FooterHead = styled.div`
  font-size: 1.4rem;
  & > img {
    width: 10rem;
    height: 4rem;
    margin-bottom: 2rem;
  }
  & > div {
    /* height: 4.2rem; */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    & > div {
      font-weight: 400;
      font-size: 1.4rem;
      line-height: 1.7rem;
      color: #888888;
    }

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-bottom: 6rem;
    }
  }
`;

export const FooterMain = styled.div`
  margin-left: 20rem;
  margin-bottom: 8rem;

  display: flex;
  justify-content: space-around;
  gap: 6rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-left: 0;
    margin-bottom: 6rem;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  line-height: 1.7rem;

  & > div:first-child {
    font-style: normal;
    font-weight: 700;
    margin-bottom: 2rem;
  }

  & > div:last-child {
    font-weight: 300;
    display: flex;
    flex-direction: column;
    color: #888888;
    line-height: 2.4rem;
    gap: 1rem;

    cursor: pointer;
    & :hover {
      color: ${MAIN_GREEN};
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 41%;
    flex: auto;
  }
`;

export const Copyright = styled(Container)`
  margin-top: 3rem;
  margin-bottom: 6rem;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: #999999;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-weight: 400;
    line-height: 1.7rem;
    margin-top: 2rem;
  }
`;
